import React from "react";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import { Allroutes } from "./components/Allroutes";

import { BrowserRouter as Router } from "react-router-dom";
import {
  Home,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday
} from "./components/days";
import { Redirect } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Allroutes />
          {new Date().getDay() === 3 ? (
            <Redirect to="/Wednesday" component={Wednesday} />
          ) : null}
          {new Date().getDay() === 1 ? (
            <Redirect to="/Monday" component={Monday} />
          ) : null}
          {new Date().getDay() === 2 ? (
            <Redirect to="/Tuesday" component={Tuesday} />
          ) : null}
          {new Date().getDay() === 4 ? (
            <Redirect to="/Thursday" component={Thursday} />
          ) : null}
          {new Date().getDay() === 5 ? (
            <Redirect to="/Friday" component={Friday} />
          ) : null}
          {new Date().getDay() === 6 ? (
            <Redirect to="/" component={Home} />
          ) : null}
          {new Date().getDay() === 0 ? (
            <Redirect to="/" component={Home} />
          ) : null}
        </div>
      </Router>
    </div>
  );
}

export default App;
